import {Action} from '@ngrx/store';
import {IPatchPostDayNoteParams} from '@app/core/services/api/day-note.service';
import {DayNote} from '@app/core/models/day-note.model';
import {Moment} from 'moment';

export enum EDayNotesActions {
	SetSelectedDayNote = '[Daynotes] Set Selected DayNote',
	PatchDayNote = '[Daynotes] Patch Day Note',
	PatchDayNoteSuccess = '[Daynotes] Patch Day Note Success',
	PostDayNote = '[Daynotes] Post Day Note',
	PostDayNoteSuccess = '[Daynotes] Post Day Note Success',
	DeleteDayNote = '[Daynotes] Delete Day Note',
	DeleteDayNoteSuccess = '[Daynotes] Delete Day Note Success',
	GetDayNotes = '[Daynotes] Get Day Notes',
	GetDayNotesSuccess = '[Daynotes] Get Day Notes Success',
	SetSelectedDate = '[Daynotes] Set Selected Date',
}

export class PatchDayNote implements Action {
	public readonly type = EDayNotesActions.PatchDayNote;

	constructor(public dayNoteId: number, public data: IPatchPostDayNoteParams) {
	}
}

export class PatchDayNoteSuccess implements Action {
	public readonly type = EDayNotesActions.PatchDayNoteSuccess;

	constructor(public dayNote: DayNote) {
	}
}

export class PostDayNote implements Action {
	public readonly type = EDayNotesActions.PostDayNote;

	constructor(public data: IPatchPostDayNoteParams) {
	}
}

export class PostDayNoteSuccess implements Action {
	public readonly type = EDayNotesActions.PostDayNoteSuccess;

	constructor(public dayNote: DayNote) {
	}
}

export class DeleteDayNote implements Action {
	public readonly type = EDayNotesActions.DeleteDayNote;

	constructor(public dayNoteId: number) {
	}
}

export class DeleteDayNoteSuccess implements Action {
	public readonly type = EDayNotesActions.DeleteDayNoteSuccess;

	constructor(public dayNoteId: number) {
	}
}

export class GetDayNotes implements Action {
	public readonly type = EDayNotesActions.GetDayNotes;

	constructor(public startDate: Moment, public endDate: Moment) {
	}
}

export class GetDayNotesSuccess implements Action {
	public readonly type = EDayNotesActions.GetDayNotesSuccess;

	constructor(public dayNotes: DayNote[]) {
	}
}

export class SetSelectedDayNote implements Action {
	public readonly type = EDayNotesActions.SetSelectedDayNote;

	constructor(public dayNote: DayNote | null | undefined, public selectedDate: Moment) {
	}
}

export class SetSelectedDate implements Action {
	public readonly type = EDayNotesActions.SetSelectedDate;

	constructor(public selectedDate: Moment, public disablePopup: boolean = false) {
	}
}

export type DayNotesActions =
	SetSelectedDayNote |
	PatchDayNote |
	PatchDayNoteSuccess |
	PostDayNote |
	PostDayNoteSuccess |
	DeleteDayNote |
	DeleteDayNoteSuccess |
	GetDayNotes |
	GetDayNotesSuccess |
	SetSelectedDate
	;
